import React, { Fragment, useState } from 'react';
import { Modal as AntModal, Button, message, Icon } from 'antd';
import { services } from '@comall-backend-builder/core';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { errorHandle } from '../../services';
import './index.less';
const { confirm } = AntModal;

export const AttributeSortingPage = (props: any) => {
    const { entity, row } = props;
    const [visible, setVisible] = useState(false);
    const [list, setList] = useState([]); // 排序数组
    const [defaultList, setDefaultList] = useState([]); // 默认数组

    // 拖动排序
    const onDragEnd = (result: any) => {
        if (!result.destination) {
            return;
        }
        const reorderedList = [...list];
        const [removed] = reorderedList.splice(result.source.index, 1);
        reorderedList.splice(result.destination.index, 0, removed);
        setList(reorderedList);
    };

    // 展示弹窗
    const onShow = () => {
        if (!!row.attrOptionValue && !!row.id) {
            services.api
                .get({}, { apiPath: `/display_category/filter_attr/${row.id}` })
                .then((res: any) => {
                    setDefaultList(res);
                    // 根据sort排序
                    const sortList = [...res];
                    sortList.sort((a, b) => a.sort - b.sort);
                    setList(sortList);
                    setVisible(true);
                })
                .catch((e: any) => {
                    errorHandle(e);
                });
        } else {
            message.warning('暂无关联属性值！');
        }
    };

    // 保存排序
    const onSave = (e: { preventDefault: () => void }) => {
        e.preventDefault();
        const attr_option_code_List = list.map((item) => item.attrOptionCode);
        let attr_option_code = '';
        // 获取排序结果
        if (attr_option_code_List.length) {
            attr_option_code = attr_option_code_List.join(',');
        }
        services.api
            .put({ attr_option_code }, { apiPath: `/display_category/filter_attr/${row.id}` })
            .then(() => {
                message.success('设置成功');
                // 列表数据刷新
                entity.search({
                    ...entity.params,
                    ...entity.filters,
                });
                setVisible(false);
            })
            .catch((e: any) => {
                errorHandle(e);
            });
    };

    // 恢复排序
    const showConfirm = () => {
        confirm({
            centered: true,
            title: ' 您确定要恢复默认排序吗？',
            content: '此操作将清除您之前的排序设置。',
            onOk() {
                setList([...defaultList]);
            },
            onCancel() {},
        });
    };

    return (
        <Fragment>
            {!row._modify && (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <a style={{ color: '#FFA929' }} type="link" onClick={onShow}>
                    属性值排序
                </a>
            )}
            <div className="attribute-sorting">
                <AntModal
                    centered
                    visible={visible}
                    title="关联属性值排序"
                    onCancel={() => {
                        setVisible(false);
                    }}
                    onOk={onSave}
                    mask
                    width={600}
                >
                    <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId="droppable">
                            {(provided: any) => (
                                <div
                                    className="droppable-box"
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                >
                                    <div className="droppable-title">
                                        <div className="item-value">属性值</div>
                                        <div className="item-label">属性名</div>
                                        <div className="item-icon">拖动调整顺序</div>
                                    </div>
                                    <div className="item-box">
                                        {list.map((item, index) => (
                                            <Draggable
                                                key={item.attrOptionCode}
                                                draggableId={item.attrOptionCode}
                                                index={index}
                                            >
                                                {(provided: any) => (
                                                    <div
                                                        className="droppable-item"
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                    >
                                                        <div className="item-value">
                                                            {item.attrOptionCode}
                                                        </div>
                                                        <div className="item-label">
                                                            {item.attrOptionValue}
                                                        </div>
                                                        <div className="item-icon">
                                                            <Icon type="menu" />
                                                        </div>
                                                    </div>
                                                )}
                                            </Draggable>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </Droppable>
                    </DragDropContext>
                    <div className="restore-btn">
                        <Button type="link" onClick={showConfirm}>
                            恢复默认
                        </Button>
                    </div>
                </AntModal>
            </div>
        </Fragment>
    );
};
